<template>
  <div class="container-lg">
    <div>
      <div :class="s.title">
        <p class="fs-3 fw-bold mb-4">
          <i class="fa-solid fa-book" />
          メニュー管理
        </p>
      </div>
      <div class="row">
        <div class="col-9" style="max-height: 80vh; overflow-y: auto;" ref="scrollContainer">
          <AdminItemList
            :items="menus"
            @update:items="menus = $event"
            :is-loading="flag.isLoading"
            :draggable="true"
            :drag-disabled="!!editId"
            :edit-id="editId"
            :item-class="s.menu"
            :edit-class="s.edit"
            :scroll-container="scrollContainer"
            empty-message="※メニューが登録されていません。新規登録してください。"
            @drag-end="onDragEnd"
            @start-edit="startEdit">
            <template #item-display="{ item, isEditing }">
              <div
                v-if="!isEditing"
                class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <div class="drag-handle me-3" style="cursor: grab;">
                    <i class="fa-solid fa-grip-vertical" style="font-size: 1.2rem; color: #999;"></i>
                  </div>
                  <div>{{ item.label || '名前未設定' }}
                    <span class="d-inline opacity-50">{{ item.name }}</span></div>
                </div>
                <div>
                  <button
                    @click="startEdit(item)"
                    class="btn btn-outline-success btn-sm">編集</button>
                </div>
              </div>
            </template>
            <template #item-edit="{ isEditing }">
              <div
                :class="s.form"
                v-if="isEditing">
                <div>
                  <label for="">ステータス</label>
                  <select
                    class="form-control form-control-sm"
                    name="flag"
                    id="flag"
                    v-model="updateData.flag">
                    <option
                    v-for="(flag) of saleFlag"
                    :key="flag.label"
                    :value="flag.value">{{ flag.label }}</option>
                  </select>
                </div>
                <div class="mt-3">
                  <label for="">メニュー名</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="updateData.label">
                </div>
                <div class="mt-3">
                  <label for="">メニュー名(管理)</label>
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    v-model="updateData.name">
                </div>
                <div class="d-flex mt-3">
                  <button
                    class="btn btn-primary btn-sm"
                    :disabled="!updateData.flag || !updateData.name || !updateData.label"
                    @click="regist">更新</button>
                  <button
                    @click="cancelEdit()"
                    class="btn btn-outline-danger btn-sm ms-2">キャンセル</button>
                </div>
              </div>
            </template>
          </AdminItemList>
        </div>
        <div class="col-3 cards">
          <AdminSearchCard
            :keyword="searchParams.keyword"
            :flag="searchParams.flag"
            @update:keyword="searchParams.keyword = $event"
            @update:flag="searchParams.flag = $event"
            :flag-options="saleFlag"
            :form-class="s.form"
            keyword-placeholder="メニュー名を入力" />
          <AdminCreateCard
            :disabled="!label || !name || editId"
            :form-class="s.form"
            @submit="regist">
            <template #fields>
              <div class="mt-3 text-start">
                <label for="email" class="ms-1">メニュー名</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="label"
                  :disabled="editId"
                  placeholder="ドリンク">
              </div>
              <div class="mt-3 text-start">
                <label for="email" class="ms-1">メニュー名(管理)</label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="name"
                  :disabled="editId"
                  placeholder="drink">
              </div>
            </template>
          </AdminCreateCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AdminItemList from '@/components/admin/AdminItemList.vue';
import AdminSearchCard from '@/components/admin/AdminSearchCard.vue';
import AdminCreateCard from '@/components/admin/AdminCreateCard.vue';

export default {
  name: 'admin-menu',
  components: {
    AdminItemList,
    AdminSearchCard,
    AdminCreateCard,
  },
  data() {
    return {
      scrollContainer: null,
      flag: {
        isLoading: true,
        changeKeyword: false,
      },
      validationFlags: {
        mail: false,
      },
      invalids: {
        mail: true,
      },
      // 有効期限切れでリダイレクトされた
      menus: [],
      searchParams: {
        flag: 1,
        keyword: null,
      },
      label: null,
      name: null,
      updateData: {
        flag: null,
        label: null,
        name: null,
      },
      saleFlag: [
        {
          name: 'flag',
          label: '公開中',
          value: '1',
          hover: false,
        },
        {
          name: 'flag',
          label: '停止中',
          value: '0',
          hover: false,
        },
      ],
      editId: null,
      targetColumns: ['name', 'label'], // 検索対象のカラム
    };
  },
  created() {
    this.getMenus();
  },
  mounted() {
    this.scrollContainer = this.$refs.scrollContainer;
  },
  computed: {
    ...mapState(['user']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.mail;
    },
    getMenuOptions() {
      return this.menus.map(type => ({
        id: type.id,
        label: type.label,
      }));
    },
  },
  watch: {
    menu: {
      handler() {
        this.getMenus();
      },
      deep: true,
    },
    searchParams: {
      handler() {
        if (!this.editId) {
          this.getMenus();
        }
      },
      deep: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },

    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    getMenus() {
      if (!this.user.id) return;
      this.flag.isLoading = true;

      const params = {
        user_id: this.user.id,
      };

      if (this.searchParams.flag) params.flags = [this.searchParams.flag];
      if (this.searchParams.keyword) {
        params.targetColumn = this.targetColumns;
        params.keyword = [this.searchParams.keyword];
      }

      this.axios({
        method: 'get',
        url: 'v1/menu/get/list',
        params,
      })
        .then((response) => {
          this.menus = response.data.list.data;
        })
        .catch((error) => {
          console.log(error);
          alert('エラーが発生しました。');
        })
        .finally(() => {
          this.flag.isLoading = false;
        });
    },

    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    init() {
      this.editId = null;
      this.updateData.flag = null;
      this.updateData.label = null;
      this.updateData.name = null;
      this.label = null;
      this.name = null;
    },

    startEdit(menu) {
      this.init();
      this.editId = menu.id;
      this.updateData.flag = menu.flag;
      this.updateData.label = menu.label;
      this.updateData.name = menu.name;
    },

    cancelEdit() {
      this.init();
    },

    /** サブミット */
    regist(e) {
      if (e) e.preventDefault();
      this.showLoading();

      this.flag.isLoading = true;

      const endpoint = this.editId ? 'update' : 'create';

      const data = {
        flag: this.updateData.flag || this.flag,
        label: this.updateData.label || this.label,
        name: this.updateData.name || this.name,
        user_id: this.user.id,
      };

      if (endpoint === 'create') {
        data.flag = 1;
      }
      if (endpoint === 'update') data.id = this.editId;

      this.axios({
        method: 'POST',
        url: `/v1/menu/${endpoint}`,
        data,
      })
        .then((response) => {
          const res = response.data;
          if (endpoint === 'create' && res.exists) {
            alert('メニュー名(管理)が重複しています。');
          } else if (endpoint === 'create') {
            alert('メニューを登録しました。');
            this.init();
          }
          if (endpoint === 'update') {
            alert('メニュー情報を更新しました。');
            this.init();
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading = false;
          this.getMenus();
          this.hideLoading();
        });
    },

    onDragEnd() {
      // ドラッグ終了時に並び順を更新
      this.showLoading();

      const reorderedMenus = this.menus.map((menu, index) => ({
        id: menu.id,
        sort_id: (index + 1) * 10,
      }));

      this.axios({
        method: 'post',
        url: '/v1/menu/reorder',
        data: {
          menus: reorderedMenus,
          user_id: this.user.id,
        },
      })
        .then(() => {
          // 並び順更新成功
          this.getMenus();
        })
        .catch((error) => {
          console.log(error);
          alert('並び順の更新に失敗しました。');
          // 失敗したらリロード
          this.getMenus();
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  display: flex;
  justify-content: center;
}

.title {
  text-align: center;
  color: rgba(152, 121, 89, 1);
}

.form {
  text-align: center;
}

.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}
.form {
  label {
    color: var(--label-secondary);
    font-size: 14px;
    font-weight: 700;
  }
}
.item {
  transition: all .5s;
  max-height: 80px;
  overflow: hidden;
  &.edit {
    max-height: 1000px;
  }
}

.message {
  font-size: 12px;
  text-align: center;
}

.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  input {
    width: 100%;
    padding: 13px;
    border-radius: 8px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
  }
}
.comment {
  font-size: 12px;
  color: var(--red);
}
</style>
